import { render } from "./logout-preloader.vue?vue&type=template&id=0024066b&scoped=true"
import script from "./logout-preloader.vue?vue&type=script&lang=js"
export * from "./logout-preloader.vue?vue&type=script&lang=js"

import "./logout-preloader.vue?vue&type=style&index=0&id=0024066b&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0024066b"]])

export default __exports__